import React from "react";

interface InfoTooltipProps {
  content: React.ReactNode;
  label?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ content, label = "Info" }) => (
  <div className="group relative inline-block ml-2">
    <div className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-blue-50 border border-blue-100 text-blue-700 text-[10px] font-black tracking-widest cursor-help hover:bg-blue-100 transition-colors">
      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      {label}
    </div>
    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-72 p-4 bg-[#1a1f37] text-white text-[11px] rounded-2xl opacity-0 group-hover:opacity-100 transition-all pointer-events-none z-30 shadow-2xl border border-blue-900/10 scale-95 group-hover:scale-100 origin-top leading-relaxed">
      <div className="font-black text-blue-400 mb-2 flex items-center gap-2 tracking-widest border-b border-white/10 pb-2">
        Guidance
      </div>
      {content}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 border-8 border-transparent border-b-[#1a1f37]"></div>
    </div>
  </div>
);

export default InfoTooltip;
